import React from 'react';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';

// const DragLayer = () => {
//   const {
//     itemType,
//     isDragging,
//     item,
//     initialOffset,
//     currentOffset,
//   } = useDragLayer(monitor => ({
//     item: monitor.getItem(),
//     itemType: monitor.getItemType(),
//     initialOffset: monitor.getInitialSourceClientOffset(),
//     currentOffset: monitor.getSourceClientOffset(),
//     isDragging: monitor.isDragging(),
//   }));

//   const renderItem = () => (
//     <Layout
//       width={40}
//       height={40}
//       backgroundColor="background_accent_excited"
//     />
//   );

//   const dragLayerContainer = useMemo(
//     () => ({
//       position: 'fixed' as const,
//       'pointer-events': 'none',
//       'z-index': 100,
//       left: 0,
//       top: 0,
//       width: '100%',
//       height: '100%',
//     }),
//     [],
//   );

//   const dragLayerStyle = useMemo(() => {
//     if (!initialOffset || !currentOffset) {
//       return {
//         display: 'none',
//       };
//     }

//     const {x, y} = currentOffset;

//     const transform = `translate(${x}px, ${y}px)`;
//     return {
//       transform,
//       WebkitTransform: transform,
//     };
//   }, [currentOffset, initialOffset]);

//   if (!isDragging) {
//     return null;
//   }

//   return (
//     <div style={dragLayerContainer}>
//       <div style={dragLayerStyle}>{renderItem()}</div>
//     </div>
//   );
// };

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};

export const DragAndDropProvider: React.FC<Props> = ({children}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      {children}
      {/* <DragLayer /> */}
    </DndProvider>
  );
};
